import { apiFetch } from './client';

export const listFeedback = (token, status) =>
  apiFetch(token, status ? `/feedback?status=${encodeURIComponent(status)}` : '/feedback');

export const updateFeedbackStatus = (token, feedbackId, status) =>
  apiFetch(token, `/feedback/${feedbackId}`, { method: 'PATCH', body: JSON.stringify({ status }) });

export const deleteFeedback = (token, feedbackId) =>
  apiFetch(token, `/feedback/${feedbackId}`, { method: 'DELETE' });

export const applyFeedbackCorrection = (token, feedbackId, suggestedText) =>
  apiFetch(token, `/feedback/${feedbackId}/apply`, {
    method: 'POST',
    body: JSON.stringify({ suggested_text: suggestedText }),
  });
